import * as firebase from '../../firebaseUtil';

export default {
    state: {
        user: null,
        profileImage: null,
        storyImage: null,
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload;
        },
        setProfileImage(state, payload) {
            state.profileImage = payload;
        },
        setStoryImage(state, payload) {
            state.storyImage = payload;
        }
    },
    actions: {
        async signUserIn({commit}, payload) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const {user} = await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                  .then(() => {
                      return firebase.auth().signInWithEmailAndPassword(payload.email, payload.password);
                  }).catch((e) => console.log(e.message));
                commit('setLoading', false);
                console.log(user);
                commit('setUser', user);
            } catch (e) {
                console.error(e);
                commit('setLoading', false)
            }
        },
        async signUserInWithFacebook({commit}) {
            commit('setLoading', true);
            try {
                const {user} = await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                  .then(() => {
                      return firebase.auth().signInWithPopup(new firebase.auth.FacebookAuthProvider())
                  }).catch((e) => console.log(e.message));
                commit('setLoading', false);
                console.log(user);
                commit('setUser', user);
            } catch (e) {
                console.error(e);
                commit('setLoading', false)
            }
            commit('clearError');
        },
        async signUserInWithGoogle({commit}) {
            commit('setLoading', true);
            try {
                const {user} = await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                  .then(() => {
                      return firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider())
                  }).catch((e) => console.log(e.message));
                commit('setLoading', false);
                console.log(user);
                commit('setUser', user);
            } catch (e) {
                console.error(e);
                commit('setLoading', false)
            }
        },
        async logout({commit}) {
            const result = await firebase.auth().signOut();
            console.log(result);
            commit('setUser', null);
        },
        setUser({commit}, user) {
            commit('setUser', user)
        }
    },
    getters: {
        user(state) {
            return state.user
        }
    }
}
